// extracted by mini-css-extract-plugin
export var card = "links-features-module--card--76e4f";